import { Badge } from '@mantine/core';

interface Props {
  /** Estado que va. `true` = activo, `false` = inactivo. */
  activo: boolean;
  /** Etiqueta cuando esta inactivo. Por defecto 'Inactivo'. */
  inactiveLabel?: string;
  /** Etiqueta cuando esta activo. Por defecto 'Activo'. */
  activeLabel?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

/**
 * Badge "Activo"/"Inactivo" compartido por empresas, vehiculos, conductores
 * y origenes/destinos. Color verde (deca) cuando esta activo, gris cuando no.
 */
export function StatusBadge({
  activo,
  inactiveLabel = 'Inactivo',
  activeLabel = 'Activo',
  size = 'sm',
}: Props) {
  if (activo) {
    return (
      <Badge size={size} color="deca" variant="light" radius="sm">
        {activeLabel}
      </Badge>
    );
  }
  return (
    <Badge size={size} color="gray" variant="light" radius="sm">
      {inactiveLabel}
    </Badge>
  );
}
